import { state } from "../context/store";
function resetModel() {
  //   console.log("New Design");
  state.current.optionPage = 0;
  state.current.currentStep = 0;
  state.initialChoices = {
    activeSeat: null,
    threeDModel: "null",
    type: { index: null, name: "Select your Bike Type" },
    make: { index: null, name: "Select your Bike Type First" },
    model: { index: null, name: "Select your Make First" },
    year: { index: null, name: "Select your Model First" },
    inhouseCode: null,
    logoSize: null,
    ribLimit: 6,
  };
  state.current.choices.topPanel.selected = {
    name: "White",
    hex: "#ddd",
    src: null,
  };
  state.current.choices.sidePanels.selected = {
    mode: "regular",
    name: "White",
    hex: "#ddd",
  };
  state.current.choices.ribs.selected = {
    mode: "no",
    rib: [
      { name: "White", hex: "#ddd", src: null },
      { name: "White", hex: "#ddd", src: null },
      { name: "White", hex: "#ddd", src: null },
      { name: "White", hex: "#ddd", src: null },
      { name: "White", hex: "#ddd", src: null },
      { name: "White", hex: "#ddd", src: null },
      { name: "White", hex: "#ddd", src: null },
      { name: "White", hex: "#ddd", src: null },
      { name: "White", hex: "#ddd", src: null },
      { name: "White", hex: "#ddd", src: null },
    ],
  };
  state.current.choices.sideLogos.selected =
    state.current.initialChoices.sideLogos;
  state.current.choices.topLogo.selected = state.current.initialChoices.topLogo;
  // state.current.choices.topLogo.selected = { mode: "enjoy", name: "EnjoyMfg" };
  state.current.choices.sealant.selected = {
    mode: "no",
    name: "No Sealant",
  };
  state.current.choices.raceNumber.selected = {
    mode: "none",
    name: "white",
    outlineName: "black",
    number: "",
    hex: "#f5f5f5",
    outlineHex: "#111111",
    font: "old-english.ttf",
  };
  state.current.status.termsChecked = false;
  state.current.status.terms2Checked = false;
  state.current.modal.selectModel = true;
  state.current.modal.open = true;

  // state.modalResetCustomisationOpen = false
  // state.confirmRepick = false
  // state.settingModelType = true
  // state.sidePanelMode = 'regular'
  // state.currentRibAmount = null
  // state.ribColorMode = 'single'
  // state.sealantMode = 'no'

  // state.settingModel = true
  // state.modalResetCustomisationOpen = false
  // state.confirmReset = false
  // state.modalOpen = false
  // state.cameraControls.position = [3.5, 1, 1]
  // state.cameraControls.target = [0, 0, 0]
}

export default resetModel;
